<script setup lang="ts">
  import { useUserStore } from "~/stores/UserStore";

  interface Props {
    isTest?: boolean; // テスト時のみ true にする。でないと v-dialog を find できないため
  }
  defineProps<Props>();

  const modal = ref(false);
  const userStore = useUserStore();

  const openModal = async (userId: any) => {
    await userStore.fetchOther(userId, false);
    modal.value = true;
  };

  defineExpose({
    openModal,
  });
</script>

<template>
  <!-- プロフィールモーダル用処理 -->
  <v-dialog v-model="modal" :max-width="450" scrim="black" :attach="!!isTest">
    <v-card class="profileDialog">
      <v-btn class="closeBtn" icon="$close" variant="text" @click="modal = false"></v-btn>
      <div class="profileIcon">
        <AtomsImgWithLoading class="rounded-circle" :src="userStore.otherUser?.userImage" :width="120" :height="120" />
      </div>
      <div class="profileName text-dialog-title">{{ userStore.otherUser?.userName }}</div>
      <div class="profileDescription text-dialog-description scroll-y">{{ userStore.otherUser?.userDescription }}</div>
      <v-sheet color="transparent" align="center">
        <AtomsDialogButton link nuxt @click="modal = false"> 戻る </AtomsDialogButton>
      </v-sheet>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
  @import "assets/media.scss";

  .profileDialog {
    position: relative;
    text-align: center;
    background-color: #222222;
    padding: 40px 60px;
    @include display_sp {
      padding: 40px 20px;
    }
    .closeBtn {
      position: absolute;
      right: 0;
      top: 0;
    }
    .profileIcon {
      margin: 0 auto;
      margin-bottom: 20px;
    }
    .profileName {
      padding-bottom: 20px;
    }
    .profileDescription {
      margin-bottom: 40px;
      max-height: 160px;
    }
  }
</style>
